import VCardEditor from 'diy/vcard/integration';
import AutoLayerManager from './autolayermanager/AutoLayerManager';
import ImportProcedure from './externalwebsiteimport/ImportProcedure';
import WebcomponentUpsell from './app-upsell/webcomponentUpsell';
import {showNotification as showWcPageNotification} from 'diy/app/webcomponentPageNotification';
import features = require('./util/features');
import StoreProvider from "diy/redux/StoreProvider";

import MomentsToCelebrate, {CelebrationTypes} from 'diy/moments-to-celebrate/MomentsToCelebrate';

import websiteData = require('diy/util/websiteData');
import AppRegistry from "diy/AppRegistry";
import * as ModuleActionBar from 'diy/module-action-bar/index';
import * as SiteAdmin  from 'diy/site-admin/index';
import * as Overlay from 'diy/overlay/index';
import * as ModuleSectionApp from "./module/section/index";
import * as Module from 'diy/module/index';
import $ = require('jquery');

import {Api} from './Api';

import {App as ToolbarApp} from './toolbar/App';
import {App as NotificationApp} from './toolbar/notification/App';
import {App as DomainPromoApp} from './domainpromo/App';
import {App as ChatApp} from './chat/App';
import {App as BrowserUpgradeApp} from './browser-upgrade/App';
import {App as NotPublishedApp} from './not-published/App';
import ResourceManager from 'diy/resources/Manager';
import ResourceFactory from 'diy/resources/Factory';

import moduleSelector from 'diy/site-admin/module-selector/moduleSelector';

import NotificationApi from "./toolbar/notificationNG/Api";
import NotificationPoller from "./toolbar/notificationNG/Poller";
import NotificationType from "./toolbar/notificationNG/definitions/Type";

import * as bsaEvents from 'diy/bsa-events/bsaEvents';

let injectTapEventPlugin: any = require("react-tap-event-plugin");
let SiteAdminApi = require<any>('diy/site-admin/main/api');

export class App {
    vCardEditor: VCardEditor;
    api: Api;
    layerManager: AutoLayerManager;

    init() {

        // This uses the history manager to react to a certain location hash.
        // The history manager will use hashes in the form #hm:<element>:<event>
        // to trigger the indicated event on the indicated element id. Therefore
        // we create a dummy element by the name of our choice and a bogus event
        // to set up a desired reaction.
        // FIXME: move this to its own component.
        $(() => {
            $('<div/>')
                // this will show on the url, make it some sort of standard
                .attr('id', 'cc-og-step')
                // this will also show on the url and needs to look expressive
                .on('online-business-card', () => {
                    // open the onboarding guide siteadmin entry with a parameter
                    // that will override the default step selected when it opens
                    SiteAdminApi.triggerMenuItem('cc-sa-item-onboardingguide', {jumpToStep: "vcard"});
                })
                // this is the default event and can be omitted on the URL
                .on('click', () => {
                    // open the onboarding guide siteadmin entry without parameters,
                    // meaning that the onboarding guide app will decide which step
                    // to select based on its current internal logic
                    SiteAdminApi.triggerMenuItem('cc-sa-item-onboardingguide');
                })
                .appendTo($(document.body))
            ;
        });

        bsaEvents.attachEvents();
        injectTapEventPlugin();

        const storeProvider = new StoreProvider();
        const resourceManager = new ResourceManager(new ResourceFactory);
        AppRegistry
            .setStoreProvider(storeProvider)
            .setResourceManager(resourceManager);

        this.api = new Api(this);
        this.api.init();

        this.vCardEditor = new VCardEditor;

        require('./module/emotion-header/init');

        require('./angular/autoload');
        require('./uiPreference/init');

        if (jimdoData.personaTrackingEnabled) {
            require('./performanceTracking/init');
        }

        // Site-admin
        let siteAdmin: any = require('diy/site-admin/main/siteadmin');
        $(() => {
            siteAdmin.init();
            // initialize site admin redux state management
            SiteAdmin.init(storeProvider);
        });

        // Auto Layer Manager
        let WAITING_TIME_AFTER_PAGELOAD = 5000;
        this.layerManager = new AutoLayerManager();

        $(document).ready(() => {
            setTimeout(() => this.layerManager.unblockAndProcessQueue(), WAITING_TIME_AFTER_PAGELOAD);
        });

        // Notification center
        let notificationApp = new NotificationApp();
        if (!features('notificationsNG')) {
            notificationApp.initApi();
        }

        // Toolbar
        let toolbarApp = new ToolbarApp(this.vCardEditor);
        $(document).ready(() => {
            toolbarApp.init();
            $(document).bind('diy-maintenance-mode-show', () => toolbarApp.showPublishDialog());

            this.vCardEditor.setToolbar(toolbarApp.getToolbar());
            this.vCardEditor.init();
            $(document).bind('diy-maintenance-mode-edit', () => {
                this.vCardEditor.open({context: "onboardingGuide"});
            });

            if (features('notificationsNG')) {
                NotificationApi.init(storeProvider, toolbarApp);
                NotificationPoller.init(storeProvider);

                // Notification launching the "No Domain" module
                let domainPromoApp = new DomainPromoApp();
                domainPromoApp.init();

                // Notification launching the Chat
                let chatApp = new ChatApp();
                chatApp.init();

                // Browser Upgrade Notification
                let browserUpgradeApp = new BrowserUpgradeApp();
                browserUpgradeApp.init();

                // Not Published Notification
                let notPublishedApp = new NotPublishedApp();
                notPublishedApp.init();

            } else {
                notificationApp.setToolbar(toolbarApp.getToolbar());
                notificationApp.setLayerManager(this.layerManager);
                notificationApp.init();
            }
        });

        // Undo redo
        let UndoRedo: any = require('diy/undo-redo/UndoRedo');

        this.api.initUndoRedoApi(UndoRedo.startApi());

        $(document).ready(() => {
            UndoRedo.onReady((<any>jimdoData).features, toolbarApp.getToolbar());
        });

        // XXX Chat is also used in help iframe with global namespace
        if (features('chat1and1')) {
            require('../js/chat/1and1');
        }
        if (features('chatYalst')) {
            require('../js/chat/yalst');
        }

        $(document).ready(() => {
            require('../js/survey/surveyScriptLoader');
        });

        //TODO: AIONDEBUG
        let momentsToCelebrate = new MomentsToCelebrate();

        $(document).bind('diy-maintenance-mode-vcard-publish', () =>
            momentsToCelebrate.show(CelebrationTypes.Vcard)
        );
        $(document).bind('diy-maintenance-mode-publish', () =>
            momentsToCelebrate.show(CelebrationTypes.Publish)
        );

        // Landscape mode
        if ((features('showTabletLandscapeInfo') && diy.editor.uiPreference.isPointerModeTouch())) {
            let landscapeMode: any = require('./tablet/landscapeModeInfo');
            $(() => {
                landscapeMode.showTabletLandscapeNotification();
            });
        }

        // Tariff Update
        let tariffUpdate: any = require('./tariffupdate/tariffUpdate');

        if (features('updateTariffNewRibbons') || features('orderFinalized') || features('updateTariff')) {
            tariffUpdate.setLayerManager(this.layerManager);
            tariffUpdate.init();
        }

        // Website Import (WSB / WSC)
        if (features('externalWebsiteMigration')) {
            let websiteImport = new ImportProcedure();

            $(document).ready(() => {
                if (features('notificationsNG')) {
                    websiteImport.init(websiteData.getId());
                } else {
                    websiteImport.init(
                        websiteData.getId(),
                        notificationApp.getApi()
                    );
                }
            });
        }

        // Upsell
        $(document).ready(() => {
            if (!features('notificationsNG')) {
                let webcomponentUpsell = new WebcomponentUpsell();
                webcomponentUpsell.setApi(notificationApp.getApi());

                for (let webComponent of jimdoData.webComponentUpsell) {
                    if (webComponent['status-code'] === "INITIAL" || webComponent['status-code'] === "PROCESSING") {
                        webcomponentUpsell.startPolling(webComponent.webComponentId);
                    } else if (webComponent['status-code'] === "SUCCESS") {
                        webcomponentUpsell.showNotification(webComponent);
                    }
                }
            }
        });
        
        // Aviary Notification
        $(document).ready(() => {
            if (features('notificationsNG')) {
                if (features('aviaryShutdown')) {
                    NotificationApi.schedule(() => {
                        NotificationApi.pushOne({
                            type: NotificationType.AVIARY_SHUTDOWN
                        });
                    });
                } else {
                    NotificationApi.schedule(() => {
                        NotificationApi.deleteOne(
                            NotificationType.AVIARY_SHUTDOWN
                        );
                    });
                }
            }
        });

        // File Manager
        let fileManager: any = require('./filemanager/init');
        fileManager.init();

        $(document).ready(() => {
            ModuleActionBar.init(storeProvider);
            Overlay.init(storeProvider);
            Module.init(storeProvider);
            ModuleSectionApp.render(storeProvider.getStore());
        });
        ModuleSectionApp.init(storeProvider);

        // Material UI initialization (for legacy code)
        // uncomment when framework really needed in legacy code
        // require('./material-ui/legacy.js');

        $(() => {
            moduleSelector.init();
        });

        let appsCatalog: any = require('diy/site-admin/apps-catalog/appsCatalog');
        appsCatalog.init();

        // Local modules (elements)
        require('./module/init');

        // Use case feature (not sure if it's still used or not)
        let useCase: any = require('diy/use-case/index');
        $(document).ready(() => {
            useCase.init();
        });

        if (features('wbcPageNotification')) {
            let webComponentId = features
                .getPayload<{webComponentId: string}>('wbcPageNotification')
                .webComponentId;

            if (webComponentId) {
                showWcPageNotification(webComponentId);
            }
        }

        $(document).ready(() => {
            resourceManager.init();
        });

        // Detects a bug on IE9-11 that breaks the sitebuidler and notifies users
        require('diy/common/js/browserchecks');
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/App.ts
 **/